import { InputProps, SelectInput } from "react-admin"

import { BillLanguageCodeChoices } from "../../billing_constants"

export const BillLangCodeSelectInput: React.FC<InputProps> = (props) => (
  <SelectInput {...props} choices={BillLanguageCodeChoices} />
)
